/**
 * CourseColumn Configuration
 *
 * This object defines the configuration for a custom column in a table that displays course information.
 *
 * Properties:
 * @property {string} id - The unique identifier for the column.
 * @property {boolean} sort - Indicates whether the column is sortable (false in this case).
 * @property {string} text - The display text for the column header.
 * @property {string} dataField - The field in the data source that this column maps to.
 */
export const CourseColumn = {
  id: "custom",
  sort: false,
  text: "Course",
  dataField: "course.name",
};
